import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Table } from '../CommonComponents';
import { getTenantArticles, TenantArticle } from '../../api-admin/tenant-articles';

const columns = [{
    name: 'Titel',
    key: 'title',
    canSearch: true
}, {
    name: 'Status',
    key: 'statusLabel',
    canFilter: true
}, {
    name: 'Publicerad',
    key: 'publishedAt',
    type: 'datetime' as const,
    canFilter: true
}];

export default function TenantArticles() {
    const { id } = useParams() as unknown as { id: number };
    const navigate = useNavigate();
    const [articles, setArticles] = React.useState<Array<TenantArticle & { statusLabel: string }>>([]);
    const [isFetching, setIsFetching] = React.useState(true);

    React.useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const data = await getTenantArticles(id);
                if (cancelled) return;
                setArticles(data.map((article) => ({
                    ...article,
                    statusLabel: article.status === 'published' ? 'Publicerad' : 'Utkast'
                })));
            } catch (error) {
                console.error(error);
                if (!cancelled) {
                    setArticles([]);
                }
            } finally {
                if (!cancelled) {
                    setIsFetching(false);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [id]);

    return (
        <Table
            name="tenantArticles"
            columns={columns}
            data={articles}
            onRowClick={(article: { id: number }) => {
                navigate(`/tenants/${id}/articles/${article.id}/edit`);
            }}
            emptyText={isFetching ? 'Hämtar artiklar...' : 'Det finns inga artiklar.'}
            showPagination
            defaultOrderBy="publishedAt"
            defaultOrderDirection="desc"
            onAddClick={{ action: () => navigate(`/tenants/${id}/articles/create`) }}
        />
    );
}
